import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

export default class extends Controller {
  static targets = ['moreButton', 'moreText', 'show', 'hide', 'plans']

  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  className () {
    return this.element.dataset.classname
  }

  show () {
    this.plansTargets.forEach((plan) => {
      plan.classList.remove(`${this.className()}::hidden`)
    })
    this.showTarget.classList.add(`${this.className()}::hidden`)
    this.hideTarget.classList.remove(`${this.className()}::hidden`)
  }

  hide () {
    this.plansTargets.forEach((plan, idx) => {
      if (idx > 1) {
        plan.classList.add(`${this.className()}::hidden`)
      } else {
        plan.classList.remove(`${this.className()}::hidden`)
      }
    })
    this.showTarget.classList.remove(`${this.className()}::hidden`)
    this.hideTarget.classList.add(`${this.className()}::hidden`)
  }

  scrollTo (id) {
    const anchor = document.querySelector(id)
    this.scroll.animateScroll(anchor)
  }

  scrollOrRedirectToAccess (e) {
    const plansSection = document.getElementById('access')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#access')
    }
  }

  scrollOrRedirectToAdmissionPlans (e) {
    const plansSection = document.getElementById('plans')
    if (plansSection) {
      e.preventDefault()
      this.scrollTo('#plans')
    }
  }

  // NOTE: mobile側のcomponent_controller.jsにも同一メソッドあり
  // mobile/desktopは独立したViewComponentのため、共通基底クラスではなく各コントローラーに定義
  scrollToElement (e) {
    const link = e.target.closest('a')
    if (link && link.hash) {
      const element = document.querySelector(link.hash)
      if (element) {
        e.preventDefault()
        this.scroll.animateScroll(element)
        return
      }
    }
    const plansSection = document.getElementById('plans')
    if (plansSection) {
      e.preventDefault()
      this.scroll.animateScroll(plansSection)
    }
  }
}
